import { render, staticRenderFns } from "./FormNoteBlockSettings.vue?vue&type=template&id=75624220"
import script from "./FormNoteBlockSettings.vue?vue&type=script&lang=js"
export * from "./FormNoteBlockSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports